<template>
  <div id="app">
    <Nav></Nav>
    <router-view />
  </div>
</template>

<script>
import Nav from './components/shared/Nav';
export default {
  name: 'App',
  components: {
    Nav
  },
  watch: {
    $route(to, from) {
      window.scrollTo(0, 0);
    }
  },
};
</script>

<style>
@font-face {
  font-family: 'Google Sans';
  src: url('/static/fonts/GoogleSans-MediumItalic.woff2') format('woff2'),
    url('/static/fonts/GoogleSans-MediumItalic.woff') format('woff');
  font-weight: 500;
  font-style: italic;
}

@font-face {
  font-family: 'Google Sans';
  src: url('/static/fonts/GoogleSans-Medium.woff2') format('woff2'),
    url('/static/fonts/GoogleSans-Medium.woff') format('woff');
  font-weight: 500;
  font-style: normal;
}

@font-face {
  font-family: 'Google Sans';
  src: url('/static/fonts/GoogleSans-BoldItalic.woff2') format('woff2'),
    url('/static/fonts/GoogleSans-BoldItalic.woff') format('woff');
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: 'Google Sans';
  src: url('/static/fonts/GoogleSans-Bold.woff2') format('woff2'),
    url('/static/fonts/GoogleSans-Bold.woff') format('woff');
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: 'Google Sans';
  src: url('/static/fonts/GoogleSans-Italic.woff2') format('woff2'),
    url('/static/fonts/GoogleSans-Italic.woff') format('woff');
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: 'Google Sans';
  src: url('/static/fonts/GoogleSans-Regular.woff2') format('woff2'),
    url('/static/fonts/GoogleSans-Regular.woff') format('woff');
  font-weight: normal;
  font-style: normal;
}

html {
  box-sizing: border-box;
  background-color: #F0F0F0;
  min-width: 320px;
}

*,
*::before,
*::after {
  box-sizing: inherit;
}

* {
  margin: 0;
  padding: 0;
}

#app {
  color: #3f3f3f;
  font-family: 'Google Sans', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
h1 {
  font-size: 70px;
  font-weight: 400;
  line-height: 70px;
}
h2 {
  font-size: 52px;
  font-weight: 400;
  line-height: 52px;
}
h4 {
  font-size: 36px;
  font-weight: 400;
}
h6 {
  font-size: 28px;
  font-weight: 400;
}
p {
  font-size: 18px;
  color: rgba(63, 63, 63, 0.8);
}
a {
  text-decoration: none;
}

/* ***** */
/* CONTACTS */
/* ***** */

/* GOOGLE MAPS */
/* MAP */
/* The location pointed to by the popup tip. */
.popup-tip-anchor {
  height: 0;
  position: absolute;
  /* The max width of the info window. */
  transform: translateX(50px) translateY(-100px);
  width: 200px;
}
/* The bubble is anchored above the tip. */
.popup-bubble-anchor {
  position: absolute;
  width: 100%;
  bottom: /* TIP_HEIGHT= */ 8px;
  left: 0;
}
.maps-cdots {
  width: 200px;
}
/* The popup bubble itself. */
.popup-bubble-content {
  position: absolute;
  top: 0;
  left: 0;
  /* Style the info window. */
  background-color: transparent;
  padding: 5px;
  border-radius: 5px;
  font-family: sans-serif;
}
/* hide google captcha */
.grecaptcha-badge {
    visibility: hidden;
}

.contacts-left-btn1 {
  align-items: center;
  background-color: rgb(0, 18, 34);
  color: #fff;
  cursor: pointer;
  line-height: 18px;
  display: inline-flex;
  font-size: 18px;
  font-weight: 600;
  height: 45px;
  justify-content: center;
  margin-top: 12px;
  width: 178px;
}
.contacts-left-btn1:hover {
  background-color: #191b1d;
}
.contacts-left-btn {
  align-items: center;
  background-color: #000;
  color: #fff;
  cursor: pointer;
  display: inline-flex;
  font-size: 18px;
  font-weight: 600;
  height: 45px;
  justify-content: center;
  margin-top: 25px;
  width: 178px;
}
.contacts-left-btn:hover {
  background-color: #191b1d;
}
.contacts-inquiry-btn {
  display: none;
}
.not-valid {
  color: red !important;
}
.not-valid-border {
  border-color: red !important;
}
.video {
  background-color: #f8f8f8;
  cursor: pointer;
  padding: 5px;
  margin-right: 40px;
  width: calc(50% - 40px);
}
.video p {
  font-size: 12px;
  line-height: 14px;
  margin: 3px 0;
}
.video p strong {
  font-size: 14px;
}
.video img {
  width: 100%;
}
.video:hover {
  opacity: 0.8;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
@media screen and (max-width: 1600px) {
  h1 {
    font-size: 56px;
    line-height: 56px;
  }
  h2 {
    font-size: 42px;
    line-height: 42px;
  }
  h4 {
    font-size: 32px;
  }
  h6 {
    font-size: 22px;
  }
  p {
    font-size: 16px;
  }
    .video {
    width: calc(40% - 40px);
  }
}
@media screen and (max-width: 1440px) {
  h1 {
    font-size: 52px;
    line-height: 52px;
  }
  h2 {
    font-size: 32px;
    line-height: 32px;
  }
  h4 {
    font-size: 28px;
  }
  h6 {
    font-size: 20px;
  }
  .contacts-left-btn1 {
    font-size: 14px;
  }
  .contacts-left-btn {
    font-size: 14px;
  }
}
@media screen and (max-width: 1366px) {
  h1 {
    font-size: 42px;
    line-height: 42px;
  }
  h2 {
    font-size: 28px;
    line-height: 28px;
  }
  h4 {
    font-size: 20px;
  }
  h6 {
    font-size: 18px;
  }
  p {
    font-size: 14px;
  }
}
@media screen and (max-width: 1280px) {
  .contacts-inquiry-btn {
    display: inline-flex;
    margin-top: 10px;
  }
  .video {
    margin: 40px 0 0;
    padding: 10px;
    width: 50%;
  }
}
@media screen and (max-width: 800px) {
  h1 {
    font-size: 24px;
    line-height: 24px;
  }
  h6 {
    font-size: 15px;
  }
  p {
    font-size: 14px;
  }
}
@media screen and (max-width: 600px) {
  .video {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue